import { render, staticRenderFns } from "./InspectRight.vue?vue&type=template&id=1e33336b&scoped=true"
import script from "./InspectRight.vue?vue&type=script&lang=js"
export * from "./InspectRight.vue?vue&type=script&lang=js"
import style0 from "./InspectRight.vue?vue&type=style&index=0&id=1e33336b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e33336b",
  null
  
)

export default component.exports